import { computed } from "mobx";
import { observer } from "mobx-react-lite";
import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import useDealsWithFocusArea from "../../hooks/useDealsWithFocusArea";
import useDealsWithGlobalFilters from "../../hooks/useDealsWithGlobalFilters";
import { usePipedriveStore } from "../../index";
import { IDetailsTabProps } from "../../interfaces/IDetailsTabProps";
import DealsGrid from "../deals/DealsGrid";

function CompanyDetailsDealsTab({ visible, setEntityCount }: IDetailsTabProps) {
    const { id } = useParams();
    const pipedriveStore = usePipedriveStore();
    const deals = useDealsWithFocusArea(useDealsWithGlobalFilters(
        useMemo(() => computed(() => pipedriveStore.deals.filter(d => d.contactCompanyId && d.contactCompanyId.toString() === id)), [id]).get()
    ));

    useEffect(() => setEntityCount(deals.length), [deals]);

    if (!visible)
        return null;

    return (
        <DealsGrid deals={deals} />
    );
}

export default observer(CompanyDetailsDealsTab);